import React from 'react';
import styles from './sidebarComponent.module.css';

import packageJson from '../../../package.json';
import { useTranslation } from 'react-i18next';

const VersionText: React.FC = () => {
  const version = packageJson.version || 'N/A';
  const {t:tSidebar} = useTranslation('sidebar_config');
  return (
    <div className={styles.versiontext} style={{
      fontSize: '10px',
      fontWeight: 500,
      color: '#8F8888',
      letterSpacing: '0.5px',
      marginTop: '8px',
      marginBottom: '8px',
      marginLeft: '20px',
      opacity: 0.85,
      userSelect: 'none',
    }}>
      <span aria-label="App Version" title={`App Version: ${version}`}>
        {tSidebar('version')}: {version}
      </span>
    </div>
  );
};

export default VersionText;
